export const API_COMMON = {
  PROP_API_SYNC_PROCESS_STATUS: 'get_sync_process_status',
  PROP_API_REFRESH_ACCESS_TOKEN: 'refresh_access_token',
  PROP_API_ADVISORY_LOCK_CHECK: 'advisory_lock_check'
} as const;

export type ApiPropertyManagerKeys = keyof typeof API_COMMON;
export type ApiPropertyManagerValues = (typeof API_COMMON)[ApiPropertyManagerKeys];